<template>
 <div v-if="yesPi" class="foot-btn navbar-fixed">
    <div class="left">
      <div>
        <van-checkbox
          @click="hadlerClick"
          v-model="allChecked"
          :checked-color="$theme.main_color_btn_bg"
          icon-size="20"
        ></van-checkbox>
        <span class="txt">全选</span>
      </div>
    </div>
    <div class="right">
      <div>
        <span class="txt">已选：<span class="color-orange">{{this.choosedList.length}}</span>单</span>
        <van-button
          v-if="isPower['PRINT_PICKING_LIST']"
          class="btn"
          @click="handlerClickSave('2')"
          type="info"
        >打印拣货单</van-button>
        <van-button
          v-if="isPower['EXPRESSMAN_PRINT']"
          class="btn"
          @click="handlerClickSave('1')"
          type="info"
        >快递码</van-button> 
      </div>
    </div>
    <PickModel ref="PickModel"></PickModel>
  </div>
</template>
<script>
import PickModel from "@/views/beeorder/components/pickModel";
export default {
  name: '',
  props: {
    yesPi:{
      type:Boolean,
      default:false,
      required:true
    },
    choosedList:{
      type: Array,
      default: ()=>{
        return []
      },
      required: true
    },
    printCodeFunLoading:{
      type:Boolean,
      default:false,
      required:true
    },
    isPower: {
      default: () => {
        return {};
      },
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      allChecked: false,
      printPickLoading:false
    }
  },
  methods: {
    hadlerClick(){
      this.$emit('checkboxAllFun', this.allChecked)
    },
    /**
     * type 1/2 快递码 / 拣货单
     */
    handlerClickSave(type= '1'){
      this.$emit('printCodeFun', 'all', type)
    },
  },
  created() {
  },
  mounted(){},
  computed:{},
  components: {PickModel},
};
</script>
<style lang="less" scoped>
.foot-btn {
  background-color: #fff;
  height: 98px;
  display: flex;
  justify-content: space-between;
  align-items: center;
   .left {
    clear: both;
    margin-left: 30px;
    max-width: 120px;
    div {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .txt {
        font-size: 24px;
        color: #333333;
        padding: 0 8px;
      }
    }
    /deep/.van-checkbox__icon--checked .van-icon {
      color: #333;
    }
  }
  .right {
    flex: 1;
    clear: both;
    text-align: right;
    padding-bottom: 15px;
    div {
      .txt {
        font-size: 24px;
        color: #999999;
        padding-right: 20px;
        .color-orange{
          color:#F8A651 ;
        }
      }
      .btn {
        width: 200px;
        height: 70px;
        line-height: 70px;
        background: var(--epButtonColor);
        color: var(--epTextColor);
        border-radius: 10px;
        font-size: 24px;
        text-align: center;
        border: 0px;
        margin-right: 20px;
        box-sizing: border-box;
      }
    }
  }
}
.navbar-fixed {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  // justify-content: flex-end;
  z-index: 3;
  border-top: 0.01rem solid #fafafa;
}
</style>